import { render, staticRenderFns } from "./ModulesHeadline.vue?vue&type=template&id=b6961f8a"
import script from "./ModulesHeadline.vue?vue&type=script&lang=js"
export * from "./ModulesHeadline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports